var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * PlayFilled component
 */
export class BlocksIconPlayFilled extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span class="${componentClassName}" role="presentation">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.32112 1.12012C4.85392 1.12012 4.39454 1.23926 3.98624 1.46616C3.57009 1.6788 3.21882 2.00002 2.96966 2.39606C2.71668 2.79811 2.57862 3.26189 2.57043 3.73701L2.57031 20.2389L2.57043 20.2533C2.57862 20.7284 2.71668 21.1922 2.96966 21.5942C3.21882 21.9902 3.57009 22.3115 3.98624 22.5241C4.39454 22.751 4.85392 22.8701 5.32112 22.8701C5.79532 22.8701 6.26147 22.7473 6.67433 22.5138C6.68393 22.5084 6.69342 22.5027 6.7028 22.4969L20.0303 14.2431C20.4438 14.0339 20.7929 13.7158 21.0395 13.3225C21.2948 12.9155 21.4303 12.4447 21.4303 11.9642C21.4303 11.4836 21.2948 11.0128 21.0395 10.6059C20.7925 10.2122 20.443 9.89373 20.0289 9.68455L6.70041 1.49184C6.69182 1.48655 6.68312 1.48142 6.67433 1.47645C6.26147 1.24287 5.79532 1.12012 5.32112 1.12012Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconPlayFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconPlayFilled.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconPlayFilled.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconPlayFilled.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-play-filled') === undefined) {
    customElements.define('cat-icon-play-filled', BlocksIconPlayFilled);
}
